import * as React from 'react'
import { Row, Col } from 'reactstrap'
import { accentUtils } from '../../services/HelperService';
import { AccentCheckUnbound } from '../unbound/AccentCheckUnbound';
import { DocumentTemplateSelection } from './DocumentTemplateSelection';
import { PrintSettingSelection } from './PrintSettingSelection';
import { documentTemplateTypes, printSettingTypes } from '../../services/TemplateService';
import { getDocumentTemplateType } from '../../views/DocumentTemplatesView';
import { CustomParamsCtrl } from './custom-reports/CustomDocumentParams';





export const ParamOptions = ({
    showTaxes,
    showDiscounts,
    useLineSort,
    showMultiProducts,
    onParamChange
}) => (
    <Row>
        <Col md={3}>
            <AccentCheckUnbound
                tagName="checkIncTax"
                defaultValue={showTaxes}
                onChange={(e) => onParamChange({ Tax: e.checked })}
                label="Show Tax Inclusive"
            />
        </Col>
        <Col md={3}>
            <AccentCheckUnbound
                tagName="checkShowDisc"
                defaultValue={showDiscounts}
                onChange={(e) => onParamChange({ Disc: e.checked })}
                label="Show Discounts"
            />
        </Col>
        <Col md={3}>
            <AccentCheckUnbound
                tagName="checkUserSortOrder"
                defaultValue={useLineSort}
                onChange={(e) => onParamChange({ Sort: e.checked })}
                label="Use Line Sort"
            />
        </Col>
        <Col md={3}>
            <AccentCheckUnbound
                tagName="checkMultiProducts"
                defaultValue={showMultiProducts}
                onChange={(e) => onParamChange({ Multi: e.checked })}
                label="Show Multi-Products"
            />
        </Col>
    </Row>
);


export class QuoteParamsCtrl extends React.Component {
    constructor(props) {
        super(props);

        // Initialize parameters
        this.showTaxes = true;
        this.showDiscounts = false;
        this.useLineSort = true;
        this.printSettingID = null;
        this.showMultiProducts = false;
        this.documentTemplateID = null;
        this.customDocumentID = null;
        this.customDocumentVersionID = null;
        this.customizationID = null; // pdfscript template behind the selected row (its params[] feed CustomParamsCtrl)
        this.signature = null;
        this.customParams = {}; // Initialize custom params
        this.state = { isPdfScript: false }; // hides the system toggles a pdfscript template ignores

        this.documentTempateReady = false;
        this.printSettingsReady = false;

        if (!accentUtils.isNull(this.props.document) && !accentUtils.isNull(this.props.document.Params)) {
            const params = this.props.document.Params;
            this.showTaxes = params.Tax;
            this.showDiscounts = params.Disc;
            this.useLineSort = params.Sort;
            this.showMultiProducts = params.Multi;
            this.printSettingID = params.PS;
            this.documentTemplateID = params.DT;
            this.customDocumentID = params.CD;
            this.customDocumentVersionID = params.CDV;
            this.signature = params.SIG;
        }

        // Initialize custom params from document.CustomParams
        if (!accentUtils.isNull(this.props.document) && !accentUtils.isNull(this.props.document.CustomParams)) {
            this.customParams = this.props.document.CustomParams;
        }

        this.handleParamChange = this.handleParamChange.bind(this);
        this.handleCustomParamsChange = this.handleCustomParamsChange.bind(this);
        this.getParams = this.getParams.bind(this);
        this.notifyHeaderReady = this.notifyHeaderReady.bind(this);
    }

    notifyHeaderReady() {
        if (this.documentTempateReady && this.printSettingsReady && this.props.onReady) {
            this.props.onReady();
        }
    }

    // Build the unified params object
    getParams() {
        return {
            Disc: this.showDiscounts,
            Tax: this.showTaxes,
            Sort: this.useLineSort,
            Multi: this.showMultiProducts,
            PS: this.printSettingID,
            DT: this.documentTemplateID,
            SIG: this.signature,
            CD: this.customDocumentID,
            CDV: this.customDocumentVersionID
        };
    }

    // Single onChange event handler for params
    handleParamChange(changed) {
        if (changed.Tax !== undefined) {
            this.showTaxes = changed.Tax;
        }
        if (changed.Disc !== undefined) {
            this.showDiscounts = changed.Disc;
        }
        if (changed.Sort !== undefined) {
            this.useLineSort = changed.Sort;
        }
        if (changed.Multi !== undefined) {
            this.showMultiProducts = changed.Multi;
        }

        // Build the unified params object
        const params = this.getParams();

        // Update document params if available
        if (!accentUtils.isNull(this.props.document)) {
            this.props.document.Params = params;
        }

        // Optionally notify a parent component with both params and customParams
        if (this.props.onChange) {
            this.props.onChange(params, this.customParams);
        }

        // Trigger a refresh
        this.props.refresh();
    }

    // Handler for custom params changes
    handleCustomParamsChange(customParams) {
        this.customParams = customParams || {};
        
        // Update document.CustomParams
        if (!accentUtils.isNull(this.props.document)) {
            this.props.document.CustomParams = this.customParams;
        }

        // Build the unified params object for onChange
        const params = this.getParams();

        // Notify parent component with both params and customParams
        if (this.props.onChange) {
            this.props.onChange(params, this.customParams);
        }

        // Trigger a refresh
        this.props.refresh();
    }

    // For non-checkbox changes, we can wrap handleParamChange as needed
    onDocumentTemplateChanged(e) {
        this.documentTemplateID = e?.ID;
        this.customDocumentID = e?.CustomDocumentID;
        this.customDocumentVersionID = e?.CustomDocumentVersionID;
        this.customizationID = e?.CustomizationID ?? null;

        // pdfscript templates are settings-blind (QuoteDataSource.NormaliseArgs fixes Disc/Tax/Sort/Multi): the
        // template decides what to show, through its own params[]; the system toggles would be dead controls
        const isPdfScript = !accentUtils.isNull(this.customizationID);
        if (isPdfScript !== this.state.isPdfScript) {
            this.setState({ isPdfScript });
        }

        this.handleParamChange({});
    }

    onPrintSettingChanged(e) {
        this.printSettingID = e;
        this.handleParamChange({});
    }

    render() {
        return (
            <Row className="rtl-quote-params">
                <Col md={12}>
                    <Row>
                        <Col md={6}>
                            <DocumentTemplateSelection
                                required
                                defaultValue={this.documentTemplateID}
                                type={this.props.type}
                                onChange={(e) => this.onDocumentTemplateChanged(e)}
                                onReady={(e) => {
                                    this.documentTempateReady = true;
                                    this.onDocumentTemplateChanged(e);
                                    this.notifyHeaderReady();
                                }}
                            />
                        </Col>
                        <Col md={6}>
                            {/* the print setting follows the template's kind where the type has a pdf kind (Installer): a pdfscript install
                                sheet takes a PDF print setting (product options only); keyed so the list and its default re-resolve on a change */}
                            <PrintSettingSelection
                                key={`ps_${this.state.isPdfScript}`}
                                defaultValue={this.printSettingID}
                                onChange={(e) => this.onPrintSettingChanged(e)}
                                onReady={(e) => {
                                    const firstReady = !this.printSettingsReady;
                                    this.printSettingsReady = true;
                                    this.onPrintSettingChanged(e);
                                    if (firstReady) this.notifyHeaderReady();
                                }}
                                type={printSettingTypes.for(getDocumentTemplateType(this.props.type), this.state.isPdfScript)}
                            />
                        </Col>
                    </Row>
                    {!this.state.isPdfScript && (
                        <ParamOptions
                            showTaxes={this.showTaxes}
                            showDiscounts={this.showDiscounts}
                            useLineSort={this.useLineSort}
                            showMultiProducts={this.showMultiProducts}
                            onParamChange={this.handleParamChange}
                        />
                    )}
                    <CustomParamsCtrl
                        customDocumentID={this.customDocumentID}
                        customDocumentVersionID={this.customDocumentVersionID}
                        customizationID={this.customizationID}
                        defaultCustomParamValues={this.customParams}
                        onCustomParamsChange={this.handleCustomParamsChange}
                    />
                </Col>
            </Row>
        );
    }

}

export class InvoiceParamsCtrl extends React.Component {

    constructor(props) {
        super(props);


        this.showTaxes = true;
        this.showDiscounts = false;
        this.useLineSort = true;
        this.showMultiProducts = false;
        this.printSettingID = null;
        this.documentTemplateID = null;
        this.customizationID = null; // pdfscript template behind the selected row (its params[] feed CustomParamsCtrl)
        this.customParams = {};
        this.state = { isPdfScript: false }; // hides the system toggles a pdfscript template ignores

        this.documentTempateReady = false;
        this.printSettingsReady = false;


        if (!accentUtils.isNull(this.props.document)) {

            if (!accentUtils.isNull(this.props.document.Params)) {
                this.showTaxes = this.props.document.Params.Tax;
            }

            if (!accentUtils.isNull(this.props.document.Params.Sort)) {
                this.useLineSort = this.props.document.Params.Sort;
            }
            if (!accentUtils.isNull(this.props.document.Params.Multi)) {
                this.showMultiProducts = this.props.document.Params.Multi;
            }

            this.documentTemplateID = this.props.document.Params.DT;
            this.printSettingID = this.props.document.Params.PS;

            if (!accentUtils.isNull(this.props.document.CustomParams)) {
                this.customParams = this.props.document.CustomParams;
            }
        }

        this.onDocumentTemplateChanged = this.onDocumentTemplateChanged.bind(this);
        this.handleCustomParamsChange = this.handleCustomParamsChange.bind(this);
        this.onIncTaxChanged = this.onIncTaxChanged.bind(this);
        this.updateDocumentParams = this.updateDocumentParams.bind(this);
        this.onShowMultiProductsChanged = this.onShowMultiProductsChanged.bind(this);
        this.onUseLineSortChanged = this.onUseLineSortChanged.bind(this);
        this.onPrintSettingChanged = this.onPrintSettingChanged.bind(this);
        this.onDocumentTempateReady = this.onDocumentTempateReady.bind(this);
        this.onPrintSettingsReady = this.onPrintSettingsReady.bind(this);
        this.notifyHeaderReady = this.notifyHeaderReady.bind(this);


    }


    notifyHeaderReady() {

        if (this.documentTempateReady && this.printSettingsReady) {
            if (this.props.onReady) {
                this.props.onReady();
            }
        }

    }

    onDocumentTempateReady(e) {

        this.documentTempateReady = true;
        this.onDocumentTemplateChanged(e);
        this.notifyHeaderReady();

    }

    onPrintSettingsReady(e) {

        this.printSettingsReady = true;
        this.onPrintSettingChanged(e);
        this.notifyHeaderReady();
    }

    onShowMultiProductsChanged(e) {
        this.showMultiProducts = e.checked;
        this.updateDocumentParams();
        this.props.refresh();
    }

    onUseLineSortChanged(e) {
        this.useLineSort = e.checked;
        this.updateDocumentParams();
        this.props.refresh();
    }

    onIncTaxChanged(e) {
        this.showTaxes = e.checked;
        this.updateDocumentParams();
        this.props.refresh();
    }
    onPrintSettingChanged(e) {

        this.printSettingID = e;
        this.updateDocumentParams();
        this.props.refresh();
    }

    onDocumentTemplateChanged(e) {

        this.documentTemplateID = e?.ID;
        this.customizationID = e?.CustomizationID ?? null;

        // pdfscript invoice templates are settings-blind (InvoiceDataSource.NormaliseArgs fixes Tax/Sort/Multi): the
        // template decides what to show, through its own params[]; the system toggles would be dead controls
        const isPdfScript = !accentUtils.isNull(this.customizationID);
        if (isPdfScript !== this.state.isPdfScript) {
            this.setState({ isPdfScript });
        }

        this.updateDocumentParams();
        this.props.refresh();

    }

    handleCustomParamsChange(customParams) {
        this.customParams = customParams || {};

        if (!accentUtils.isNull(this.props.document)) {
            this.props.document.CustomParams = this.customParams;
        }

        this.props.refresh();
    }


    updateDocumentParams() {
        if (!accentUtils.isNull(this.props.document)) {

            const params = {
                Disc: false,
                Tax: this.showTaxes,
                Sort: this.useLineSort,
                Multi: this.showMultiProducts,
                PS: this.printSettingID,
                DT: this.documentTemplateID

            };

            this.props.document.Params = params;
            this.props.document.CustomParams = this.customParams;
        }
    }


    render() {


        return <Row className="rtl-quote-params">
            <Col md={12}>
                <Row>
                    <Col md={6}>
                        <DocumentTemplateSelection defaultValue={this.documentTemplateID} type="Invoice" onChange={this.onDocumentTemplateChanged} onReady={this.onDocumentTempateReady} />
                    </Col>
                    <Col md={6}>
                        <PrintSettingSelection defaultValue={this.printSettingID} onChange={this.onPrintSettingChanged} onReady={this.onPrintSettingsReady} type={ documentTemplateTypes.invoice } />
                    </Col>
                </Row>
                {!this.state.isPdfScript && (
                    <Row>
                        <Col md={4}>
                            <AccentCheckUnbound tagName="checkIncTax" defaultValue={this.showTaxes} onChange={this.onIncTaxChanged} label="Show Tax Inclusive" />
                        </Col>
                        <Col md={4}>
                            <AccentCheckUnbound tagName="checkUserSortOrder" defaultValue={this.useLineSort} onChange={this.onUseLineSortChanged} label="Use Job Line Sort" />
                        </Col>
                        <Col md={4}>
                            <AccentCheckUnbound tagName="checkMultiProducts" defaultValue={this.showMultiProducts} onChange={this.onShowMultiProductsChanged} label="Show Multi-Products" />
                        </Col>
                    </Row>
                )}
                <CustomParamsCtrl
                    customizationID={this.customizationID}
                    defaultCustomParamValues={this.customParams}
                    onCustomParamsChange={this.handleCustomParamsChange}
                />
            </Col>
        </Row>;
    }
}
